<div class="flex min-h-screen bg-[#F3F4F6] font-sans">
  <aside class="w-64 bg-[#5b21b6] text-white flex flex-col shrink-0 fixed h-full z-10">
    <div class="p-6 flex items-center gap-3">
      <app-logo></app-logo>
    </div>
    <nav class="flex-1 px-4 space-y-2 mt-4">
      <a routerLink="/intake"
         class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors">
        <span class="material-icons text-xl">dashboard</span> Dashboard
      </a>
      <div class="my-2 border-l-4 border-white ml-[-16px] pl-[12px]">
        <span
              class="flex items-center gap-3 px-4 py-3 bg-white text-brand-purple rounded-lg font-medium shadow-sm w-full">
          <span class="material-icons text-xl">description</span> Application Details
        </span>
      </div>
    </nav>

    <div class="p-4 border-t border-white/10 mt-auto">
      <button (click)="logout()"
              class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors w-full">
        <span class="material-icons text-xl">logout</span> Sign Out
      </button>
    </div>
  </aside>

  <main class="flex-1 p-8 ml-64 overflow-y-auto">
    <header class="flex justify-between items-center mb-8">
      <div>
        <h1 class="text-2xl font-bold text-gray-900">Application Details for <span
                class="font-bold text-brand-purple">{{
            targetUser?.firstName }} {{ targetUser?.lastName }}</span></h1>
        <p class="text-sm text-gray-500 mt-1">Editing application for <span class="font-bold text-brand-purple">{{
            targetUser?.firstName }} {{ targetUser?.lastName }}</span></p>
      </div>
      <app-user-profile-avatar></app-user-profile-avatar>
    </header>

    @if (isLoading()) {
    <div class="space-y-6">
      <div class="bg-white p-6 rounded-xl shadow-sm border border-gray-100"><nz-skeleton [nzActive]="true"
                     [nzParagraph]="{ rows: 4 }"></nz-skeleton></div>
      <div class="bg-white p-6 rounded-xl shadow-sm border border-gray-100"><nz-skeleton [nzActive]="true"
                     [nzParagraph]="{ rows: 10 }"></nz-skeleton></div>
    </div>
    } @else {
    <form (ngSubmit)="saveApplication()"
          class="max-w-6xl mx-auto space-y-8">

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">settings</span>
          <h2 class="text-lg font-bold text-gray-900">Application Status</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Current Status</label>
            <div class="relative">
              <select [(ngModel)]="form.status"
                      name="status"
                      [disabled]="isReadOnly()"
                      class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed">
                @for(opt of statusOptions; track opt){ <option [value]="opt">{{opt}}</option> }
              </select>
              <span
                    class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
            </div>
          </div>

          @if (!isReadOnly()) {
          <div class="flex items-center gap-3 pt-6">
            <input type="checkbox"
                   id="submitState"
                   [(ngModel)]="form.submitToStateOnSave"
                   name="submitState"
                   class="w-5 h-5 text-brand-purple rounded focus:ring-brand-purple border-gray-300 cursor-pointer">
            <label for="submitState"
                   class="text-sm font-bold text-gray-700 cursor-pointer">
              Submit to State on Save
              <span class="block text-xs font-normal text-gray-500">Overrides status to "Submitted to State"</span>
            </label>
          </div>
          }
        </div>

        @if (form.status === 'Awaiting Applicant Updates') {
        <div class="mt-6 animate-in slide-in-from-top-2 fade-in">
          <label class="block text-xs font-bold text-red-600 mb-1.5 ml-1">Update Instructions (Required)</label>
          <p class="text-xs text-gray-500 mb-2 ml-1">Please describe exactly what changes the applicant needs to make.
          </p>
          <textarea [(ngModel)]="form.updateRequestNotes"
                    name="updateRequestNotes"
                    rows="3"
                    class="w-full bg-red-50 border border-red-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-200 focus:border-red-400 transition-all placeholder:text-red-300"
                    placeholder="E.g., Please upload a clearer photo of your ID and correct your mailing address zip code."></textarea>
        </div>
        }

        @if (form.statusHistory.length > 0) {
        <div class="mt-8 pt-6 border-t border-gray-100">
          <h3 class="text-sm font-bold text-gray-700 mb-4 flex items-center gap-2">
            <span class="material-icons text-base text-gray-500">history</span>
            Status History
          </h3>
          <div class="bg-gray-50 rounded-lg p-4 max-h-60 overflow-y-auto border border-gray-200">
            <ul class="space-y-4">
              @for (history of form.statusHistory; track $index) {
              <li class="relative pl-4 border-l-2 border-brand-purple/30 pb-1 last:pb-0">
                <div class="absolute -left-[5px] top-1.5 w-2 h-2 rounded-full bg-brand-purple"></div>

                <div class="flex justify-between items-start">
                  <div>
                    <p class="text-sm font-bold text-gray-900">{{ history.status }}</p>
                    <p class="text-xs text-gray-500">Updated by: <span class="font-medium text-gray-700">{{
                        history.updatedBy }}</span></p>
                  </div>
                  <div class="text-right">
                    <p
                       class="text-xs text-gray-500 bg-white px-2 py-1 rounded border border-gray-200 inline-block shadow-sm">
                      {{ history.updatedDate | date:'medium' }}
                    </p>
                  </div>
                </div>
              </li>
              }
            </ul>
          </div>
        </div>
        }
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">info</span>
          <h2 class="text-lg font-bold text-gray-900">General Information</h2>
        </div>

        <div class="mb-6">
          <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Application Zip Code *</label>
          <input type="text"
                 [(ngModel)]="form.zipcode"
                 name="zipcode"
                 [disabled]="isReadOnly()"
                 class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500"
                 placeholder="Enter 5-digit Zip Code"
                 maxlength="5"
                 required>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Who are you applying for?</label>
            <div class="flex bg-gray-50 p-1 rounded-lg border border-gray-200"
                 [class.pointer-events-none]="isReadOnly()"
                 [class.opacity-60]="isReadOnly()">
              <div (click)="form.type = 'My Family'"
                   [class.bg-brand-purple]="form.type === 'My Family'"
                   [class.text-white]="form.type === 'My Family'"
                   class="flex-1 text-center py-2.5 rounded-md text-sm font-medium cursor-pointer transition-all">My
                Family</div>
              <div (click)="form.type = 'My Self'"
                   [class.bg-brand-purple]="form.type === 'My Self'"
                   [class.text-white]="form.type === 'My Self'"
                   class="flex-1 text-center py-2.5 rounded-md text-sm font-medium cursor-pointer transition-all">My
                Self</div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">people</span>
          <h2 class="text-lg font-bold text-gray-900">Household Members</h2>
        </div>

        @for (member of form.householdMembers; track $index) {
        <div class="mb-8 p-6 bg-gray-50 rounded-xl border border-gray-200 relative">
          <div class="flex justify-between items-center mb-6">
            <h3 class="font-bold text-gray-900 flex items-center gap-2">
              <div
                   class="w-8 h-8 rounded-full bg-white text-brand-purple border border-gray-200 flex items-center justify-center font-bold text-sm shadow-sm">
                {{ $index + 1 }}</div>
              {{ member.isApplicant ? 'Applicant (Primary)' : 'Member ' + ($index + 1) }}
            </h3>
            @if (!member.isApplicant && !isReadOnly()) {
            <button type="button"
                    (click)="removeMember($index)"
                    class="text-red-500 hover:text-red-700 text-sm font-medium flex items-center gap-1 px-3 py-1 rounded-lg hover:bg-red-50 transition-colors">
              <span class="material-icons text-base">delete</span> Remove
            </button>
            }
          </div>

          <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-4">
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">First Name *</label>
              <input type="text"
                     [(ngModel)]="member.firstName"
                     [name]="'firstName' + $index"
                     [readonly]="member.isApplicant"
                     [disabled]="isReadOnly() && !member.isApplicant"
                     [class.bg-gray-100]="member.isApplicant || isReadOnly()"
                     [class.text-gray-500]="member.isApplicant || isReadOnly()"
                     [class.cursor-not-allowed]="member.isApplicant || isReadOnly()"
                     class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all"
                     required>
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Middle Name</label>
              <input type="text"
                     [(ngModel)]="member.middleName"
                     [name]="'middleName' + $index"
                     [disabled]="isReadOnly()"
                     class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Last Name *</label>
              <input type="text"
                     [(ngModel)]="member.lastName"
                     [name]="'lastName' + $index"
                     [readonly]="member.isApplicant"
                     [disabled]="isReadOnly() && !member.isApplicant"
                     [class.bg-gray-100]="member.isApplicant || isReadOnly()"
                     [class.text-gray-500]="member.isApplicant || isReadOnly()"
                     [class.cursor-not-allowed]="member.isApplicant || isReadOnly()"
                     class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all"
                     required>
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Suffix (Optional)</label>
              <div class="relative">
                <select [(ngModel)]="member.suffix"
                        [name]="'suffix' + $index"
                        [disabled]="isReadOnly()"
                        class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  <option value="">Select</option>
                  @for(suf of suffixOptions; track suf){ <option [value]="suf">{{suf}}</option> }
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Date of Birth *</label>
              <input type="date"
                     [(ngModel)]="member.dateOfBirth"
                     (change)="checkStudentStatus(member)"
                     [name]="'dob' + $index"
                     [disabled]="isReadOnly()"
                     class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Gender *</label>
              <div class="relative">
                <select [(ngModel)]="member.gender"
                        [name]="'gender' + $index"
                        [disabled]="isReadOnly()"
                        class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Marital Status *</label>
              <div class="relative">
                <select [(ngModel)]="member.maritalStatus"
                        [name]="'marital' + $index"
                        [disabled]="isReadOnly()"
                        class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  <option value="">Select Status</option>
                  @for(status of maritalStatuses; track status){ <option [value]="status">{{status}}</option> }
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
            <div class="flex gap-2">
              <div class="flex-1">
                <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Height (Optional)</label>
                <div class="relative">
                  <input type="number"
                         [(ngModel)]="member.heightFt"
                         [name]="'heightFt' + $index"
                         [disabled]="isReadOnly()"
                         class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500"
                         placeholder="Ft">
                  <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs">Ft</span>
                </div>
              </div>
              <div class="flex-1">
                <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">&nbsp;</label>
                <div class="relative">
                  <input type="number"
                         [(ngModel)]="member.heightIn"
                         [name]="'heightIn' + $index"
                         [disabled]="isReadOnly()"
                         class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500"
                         placeholder="In">
                  <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs">In</span>
                </div>
              </div>
            </div>

            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Weight (Optional)</label>
              <div class="relative">
                <input type="number"
                       [(ngModel)]="member.weightLbs"
                       [name]="'weightLbs' + $index"
                       [disabled]="isReadOnly()"
                       class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs">Lbs</span>
              </div>
            </div>

            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Is Student *</label>
              <div class="relative">
                <select [(ngModel)]="member.isStudent"
                        [name]="'isStudent' + $index"
                        [disabled]="isReadOnly()"
                        class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Citizenship Status *</label>
              <div class="relative">
                <select [(ngModel)]="member.citizenshipStatus"
                        [name]="'citizen' + $index"
                        [disabled]="isReadOnly()"
                        class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  @for(opt of citizenshipOptions; track opt){ <option [value]="opt.value">{{opt.label}}</option> }
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>

            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Social Security Number *</label>
              <div class="relative">
                <select [(ngModel)]="member.ssnStatus"
                        [name]="'ssnStatus' + $index"
                        [disabled]="isReadOnly()"
                        class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  <option value="">Select Status</option>
                  @for(opt of ssnStatusOptions; track opt){ <option [value]="opt.value">{{opt.label}}</option> }
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>

            @if(member.ssnStatus === 'haveSSN') {
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Enter SSN</label>
              <input type="text"
                     [(ngModel)]="member.ssn"
                     [name]="'ssn' + $index"
                     mask="XXX-XX-0000"
                     [hiddenInput]="true"
                     [disabled]="isReadOnly()"
                     class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500"
                     placeholder="XXX-XX-XXXX">
            </div>
            }
          </div>

        </div>
        }
        @if(!isReadOnly()) {
        <div class="mt-6 flex justify-center">
          <button type="button"
                  (click)="addMember()"
                  class="px-6 py-2.5 border-2 border-dashed border-brand-purple text-brand-purple font-semibold rounded-lg hover:bg-purple-50 transition-colors flex items-center gap-2">
            <span class="material-icons">add</span> Add Another Member
          </button>
        </div>
        }
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">home</span>
          <h2 class="text-lg font-bold text-gray-900">Contact Information</h2>
        </div>

        <div class="mb-8">
          <h3 class="text-sm font-bold text-gray-900 mb-4 bg-gray-50 p-2 rounded-md inline-block">Home Address</h3>
          <div class="grid grid-cols-1 gap-4 mb-4">
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Street Address 1 *</label>
              <input type="text"
                     [(ngModel)]="form.homeAddress1"
                     name="homeAddress1"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Street Address 2 (Optional)</label>
              <input type="text"
                     [(ngModel)]="form.homeAddress2"
                     name="homeAddress2"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">City *</label>
              <input type="text"
                     [(ngModel)]="form.city"
                     name="city"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">State *</label>
              <div class="relative">
                <select [(ngModel)]="form.homeState"
                        name="homeState"
                        [disabled]="isReadOnly()"
                        class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  @for(state of usStates; track state){ <option [value]="state">{{state}}</option> }
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Zip Code *</label>
              <input type="text"
                     [(ngModel)]="form.zipcode"
                     name="zipcode_contact"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-sm font-bold text-gray-900 bg-gray-50 p-2 rounded-md inline-block">Mailing Address</h3>
            <label
                   class="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-600 hover:text-brand-purple transition-colors">
              <input type="checkbox"
                     [(ngModel)]="form.mailingIsSameAsHome"
                     name="mailingSame"
                     [disabled]="isReadOnly()"
                     class="w-4 h-4 text-brand-purple rounded focus:ring-brand-purple border-gray-300 disabled:text-gray-400">
              Same as Home Address
            </label>
          </div>
          @if (!form.mailingIsSameAsHome) {
          <div class="grid grid-cols-1 gap-4 mb-4">
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Mailing Address 1</label>
              <input type="text"
                     [(ngModel)]="form.mailingAddress1"
                     name="mailingAddress1"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">City</label>
              <input type="text"
                     [(ngModel)]="form.mailingCity"
                     name="mailingCity"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">State</label>
              <div class="relative">
                <select [(ngModel)]="form.mailingState"
                        name="mailingState"
                        [disabled]="isReadOnly()"
                        class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                  @for(state of usStates; track state){ <option [value]="state">{{state}}</option> }
                </select>
                <span
                      class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
              </div>
            </div>
            <div>
              <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Zip Code</label>
              <input type="text"
                     [(ngModel)]="form.mailingZipCode"
                     name="mailingZipCode"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
          </div>
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4 border-t border-gray-100">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Primary Phone Number (Read Only) *</label>
            <div
                 class="w-full bg-gray-100 border border-gray-200 rounded-lg px-4 py-2.5 flex items-center cursor-not-allowed text-gray-500">
              {{ form.primaryPhone }}
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Primary Phone Type *</label>
            <div class="relative">
              <select [(ngModel)]="form.primaryPhoneType"
                      name="primaryPhoneType"
                      disabled
                      class="w-full bg-gray-100 border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none cursor-not-allowed text-gray-500">
                <option value="MOBILE">MOBILE</option>
              </select>
              <span
                    class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Secondary Phone Number (Optional)</label>
            <div class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 flex items-center focus-within:ring-2 focus-within:ring-brand-purple/20 focus-within:border-brand-purple transition-all"
                 [class.bg-gray-100]="isReadOnly()"
                 [class.pointer-events-none]="isReadOnly()">
              <intl-tel-input [initOptions]="{ initialCountry: 'us' }"
                              [initialValue]="form.secondaryPhone"
                              [disabled]="isReadOnly()"
                              (numberChange)="handleSecondaryPhoneChange($event)"></intl-tel-input>
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Secondary Phone Type (Optional)</label>
            <div class="relative">
              <select [(ngModel)]="form.secondaryPhoneType"
                      name="secondaryPhoneType"
                      [disabled]="isReadOnly()"
                      class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                <option value="">Select Type</option>
                @for(type of phoneTypes; track type){ <option [value]="type">{{type}}</option> }
              </select>
              <span
                    class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
            </div>
          </div>

          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Email Address (Read Only) *</label>
            <input type="email"
                   [(ngModel)]="form.email"
                   name="email"
                   readonly
                   class="w-full bg-gray-100 border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-500 cursor-not-allowed focus:outline-none">
          </div>
        </div>

      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">attach_money</span>
          <h2 class="text-lg font-bold text-gray-900">Financial Information</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Gross Annual Household Income *</label>
            <div class="relative">
              <span class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
              <input type="number"
                     [(ngModel)]="form.grossAnnualIncome"
                     name="income"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg pl-8 pr-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Medicare Part A Credits</label>
            <input type="number"
                   [(ngModel)]="form.medicareCredits"
                   name="medicareCredits"
                   [disabled]="isReadOnly()"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Household Assets Worth</label>
            <div class="relative">
              <span class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
              <input type="number"
                     [(ngModel)]="form.householdAssets"
                     name="assets"
                     [disabled]="isReadOnly()"
                     class="w-full bg-gray-50 border border-gray-200 rounded-lg pl-8 pr-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Weekly Work Hours</label>
            <input type="number"
                   [(ngModel)]="form.weeklyWorkHours"
                   name="workHours"
                   [disabled]="isReadOnly()"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
          </div>
          <div class="col-span-1 md:col-span-2">
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Tax Filing Status</label>
            <div class="relative">
              <select [(ngModel)]="form.taxFilingStatus"
                      name="taxFiling"
                      [disabled]="isReadOnly()"
                      class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all disabled:bg-gray-100 disabled:text-gray-500">
                <option value="SINGLE">Single</option>
                <option value="MARRIED_JOINTLY">Married Filing Jointly</option>
                <option value="MARRIED_SEPARATELY">Married Filing Separately</option>
                <option value="HEAD_OF_HOUSEHOLD">Head of Household</option>
                <option value="NOT_FILING">Not Required to File</option>
              </select>
              <span
                    class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-lg">expand_more</span>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">health_and_safety</span>
          <h2 class="text-lg font-bold text-gray-900">Health Status & Needs</h2>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
          <ng-template #yesNoQuestion
                       let-label="label"
                       let-field="field">
            <div class="flex items-center justify-between border-b border-gray-50 pb-3">
              <span class="text-sm font-medium text-gray-700">{{ label }}</span>
              <div class="flex bg-gray-50 p-1 rounded-lg border border-gray-200 w-28 shrink-0"
                   [class.pointer-events-none]="isReadOnly()"
                   [class.opacity-60]="isReadOnly()">
                <div (click)="form[field] = true"
                     [class.bg-brand-purple]="form[field] === true"
                     [class.text-white]="form[field] === true"
                     class="flex-1 text-center py-1.5 rounded text-xs font-bold cursor-pointer transition-all">Yes</div>
                <div (click)="form[field] = false"
                     [class.bg-brand-purple]="form[field] === false"
                     [class.text-white]="form[field] === false"
                     class="flex-1 text-center py-1.5 rounded text-xs font-bold cursor-pointer transition-all">No</div>
              </div>
            </div>
          </ng-template>

          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Does anyone smoke?', field: 'smoking'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Is anyone pregnant?', field: 'pregnancy'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Is anyone disabled?', field: 'isDisabled'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Is anyone blind?', field: 'isBlind'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Does anyone have diabetes?', field: 'isDiabetic'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'In postpartum period?', field: 'isPostpartumPeriod'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Has mood disorder?', field: 'hasMoodDisorder'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Has brain/spinal injury?', field: 'hasBrainSpinalInjury'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Has life-limiting illness?', field: 'hasLifeLimitingIllness'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Military affiliation?', field: 'hasMilitaryAffiliation'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Breast/Cervical cancer?', field: 'hasBreastCervicalCancer'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'HIV/AIDS diagnosis?', field: 'hasHIVAIDSDiagnosis'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Has genetic disorder?', field: 'hasGeneticDisorder'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Substance use disorder?', field: 'hasSubstanceUseDisorder'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Need rehabilitation?', field: 'hasRehabilitationNeed'}"></ng-container>

          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Does your household have a vehicle?', field: 'hasVehicle'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Is anyone currently a student?', field: 'isStudent'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Does anyone participate in medical research programs?', field: 'participatesInResearch'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Is anyone currently in foster care?', field: 'isInFosterCare'}"></ng-container>
          <ng-container
                        *ngTemplateOutlet="yesNoQuestion; context: {label: 'Does anyone have tribal membership or identify as Urban Indian?', field: 'hasTribalMembership'}"></ng-container>
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">shield</span>
          <h2 class="text-lg font-bold text-gray-900">Current Coverage</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-3">Do you currently have health insurance?</label>
            <div class="flex bg-gray-50 p-1 rounded-lg border border-gray-200"
                 [class.pointer-events-none]="isReadOnly()"
                 [class.opacity-60]="isReadOnly()">
              <div (click)="form.hasCurrentInsurance = true"
                   [class.bg-brand-purple]="form.hasCurrentInsurance === true"
                   [class.text-white]="form.hasCurrentInsurance === true"
                   class="flex-1 text-center py-2.5 rounded-md text-sm font-medium cursor-pointer transition-all">Yes
              </div>
              <div (click)="form.hasCurrentInsurance = false"
                   [class.bg-brand-purple]="form.hasCurrentInsurance === false"
                   [class.text-white]="form.hasCurrentInsurance === false"
                   class="flex-1 text-center py-2.5 rounded-md text-sm font-medium cursor-pointer transition-all">No
              </div>
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-3">Do you currently have Medicare?</label>
            <div class="flex bg-gray-50 p-1 rounded-lg border border-gray-200"
                 [class.pointer-events-none]="isReadOnly()"
                 [class.opacity-60]="isReadOnly()">
              <div (click)="form.hasMedicare = true"
                   [class.bg-brand-purple]="form.hasMedicare === true"
                   [class.text-white]="form.hasMedicare === true"
                   class="flex-1 text-center py-2.5 rounded-md text-sm font-medium cursor-pointer transition-all">Yes
              </div>
              <div (click)="form.hasMedicare = false"
                   [class.bg-brand-purple]="form.hasMedicare === false"
                   [class.text-white]="form.hasMedicare === false"
                   class="flex-1 text-center py-2.5 rounded-md text-sm font-medium cursor-pointer transition-all">No
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">event</span>
          <h2 class="text-lg font-bold text-gray-900">Qualifying Life Event</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          @for(event of lifeEvents; track event) {
          <label class="flex items-center gap-3 p-4 border rounded-xl cursor-pointer hover:bg-purple-50 hover:border-brand-purple transition-all group"
                 [class.border-brand-purple]="form.qualifyingLifeEvent === event"
                 [class.bg-purple-50]="form.qualifyingLifeEvent === event"
                 [class.border-gray-200]="form.qualifyingLifeEvent !== event"
                 [class.pointer-events-none]="isReadOnly()">
            <input type="radio"
                   [value]="event"
                   [(ngModel)]="form.qualifyingLifeEvent"
                   name="lifeEvent"
                   [disabled]="isReadOnly()"
                   class="text-brand-purple focus:ring-brand-purple w-5 h-5">
            <span class="text-sm font-medium text-gray-700 group-hover:text-brand-purple"
                  [class.text-brand-purple]="form.qualifyingLifeEvent === event">{{ event }}</span>
          </label>
          }
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">medical_services</span>
          <h2 class="text-lg font-bold text-gray-900">Health Conditions</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          @for(condition of healthConditionOptions; track condition) {
          <label class="flex items-center gap-3 p-4 border rounded-xl cursor-pointer hover:bg-purple-50 hover:border-brand-purple transition-all group"
                 [class.border-brand-purple]="form.healthConditions.includes(condition)"
                 [class.bg-purple-50]="form.healthConditions.includes(condition)"
                 [class.pointer-events-none]="isReadOnly()">
            <input type="checkbox"
                   [checked]="form.healthConditions.includes(condition)"
                   (change)="toggleCondition(condition)"
                   [disabled]="isReadOnly()"
                   class="text-brand-purple rounded focus:ring-brand-purple w-5 h-5">
            <span class="text-sm font-medium text-gray-700 group-hover:text-brand-purple"
                  [class.text-brand-purple]="form.healthConditions.includes(condition)">{{ condition }}</span>
          </label>
          }
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <div class="flex items-center gap-2 mb-6 pb-2 border-b border-gray-100">
          <span class="material-icons text-brand-purple">verified</span>
          <h2 class="text-lg font-bold text-gray-900">Attestation</h2>
        </div>

        <div class="bg-white border border-gray-300 rounded-xl p-6 mb-8 shadow-sm">
          <h3 class="text-brand-purple font-bold text-lg mb-4">Rights & Responsibilities</h3>
          <p class="font-bold text-gray-800 text-sm mb-2">I understand that:</p>
          <ul class="list-disc pl-5 space-y-1 text-sm text-gray-700 leading-relaxed">
            <li>All information I provide must be true and complete to the best of my knowledge</li>
            <li>Providing false information may be considered fraud and could result in denial of benefits and legal
              consequences</li>
            <li>I must report any changes to my household, income, or circumstances within 10 days</li>
            <li>I authorize the state to verify information with other agencies (IRS, SSA, DHS, etc.)</li>
          </ul>
        </div>

        <div class="bg-yellow-50 border border-yellow-200 rounded-xl p-6 mb-8">
          <label class="flex gap-4 cursor-pointer items-start">
            <input type="checkbox"
                   [(ngModel)]="form.attestationAgreed"
                   name="attestation"
                   [disabled]="isReadOnly()"
                   class="mt-1 text-brand-purple rounded focus:ring-brand-purple w-5 h-5">
            <span class="text-sm text-gray-800 leading-relaxed font-medium">
              I have read and agree to the above statements. Under penalty of perjury, I certify that the information
              provided is true and correct.
            </span>
          </label>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Electronic Signature</label>
            <input type="text"
                   [(ngModel)]="form.electronicSignature"
                   name="signature"
                   [disabled]="isReadOnly()"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all signature-font disabled:bg-gray-100 disabled:text-gray-500"
                   placeholder="Type full name">
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Date</label>
            <input type="date"
                   [(ngModel)]="form.attestationDate"
                   name="attestationDate"
                   class="w-full bg-gray-100 border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-500 cursor-not-allowed"
                   readonly>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-4 py-4">
        <button type="button"
                (click)="cancel()"
                class="px-10 py-3 border border-gray-300 text-gray-700 font-bold rounded-xl hover:bg-gray-50 transition-colors">
          {{ isReadOnly() ? 'Close' : 'Cancel' }}
        </button>
        @if(!isReadOnly()) {
        <button type="submit"
                [disabled]="isSaving()"
                class="px-10 py-3 bg-[#8b5cf6] text-white font-bold rounded-xl hover:bg-purple-700 transition-colors shadow-lg shadow-purple-200 disabled:opacity-70 flex items-center gap-2">
          @if(isSaving()) { <span class="material-icons animate-spin text-sm">refresh</span> }
          Save Application
        </button>
        }
      </div>

    </form>
    }
  </main>
</div>